export const NumberNames = [
  'one',
  'two',
  'three',
  'four',
  'five',
  'six'
];

// see https://github.com/Dailybreak/b2c/pull/1211/files#diff-3e5df168c68202e17f1ebc26d52349a8R61
const MAX_RESULT_TEXT_LENGTH = 55;

const renderText = html => {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return doc.querySelector('body').textContent;
};

// enforce result text character limit by first rendering the result title HTML and then
// truncating that string if appropriate.
export const createResultText = result => {
  const fullText = renderText(result.title);

  return fullText.length > MAX_RESULT_TEXT_LENGTH
    ? fullText.slice(0, MAX_RESULT_TEXT_LENGTH).concat('...')
    : fullText;
};



// WEBPACK FOOTER //
// ./public/components/forms/CustomFields/DecisionTree/utils.js